module.exports = __webpack_public_path__ + "static/media/pinned_challenge_explain.f2d9abca.png";